export const TOOLBAR_TYPE_ICON = 'icon'
export const TOOLBAR_TYPE_HIDDEN_FIELDS = 'hidden_fields'
export const TOOLBAR_TYPE_LOGO = 'logo'
export const TOOLBAR_TYPE_QUESTION = 'question'
export const TOOLBAR_TYPE_STYLING = 'styling'
export const TOOLBAR_TYPE_SUBMIT_BUTTON = 'submitButton'

export const TOOLBAR_TYPE_STYLING_BACKGROUND = 'backgroundColour'
export const TOOLBAR_TYPE_STYLING_BOLD = 'bold'
export const TOOLBAR_TYPE_STYLING_COLOR = 'colour'
export const TOOLBAR_TYPE_STYLING_COLOR_SELECTION = 'colour_selection'
export const TOOLBAR_TYPE_STYLING_COLOR_SELECTION_REMOVE = 'colour_selection_remove'
export const TOOLBAR_TYPE_STYLING_FONT = 'font'
export const TOOLBAR_TYPE_STYLING_ITALIC = 'italic'
export const TOOLBAR_TYPE_STYLING_LINK = 'link'
export const TOOLBAR_TYPE_STYLING_LINK_SELECTION = 'link_selection'
export const TOOLBAR_TYPE_STYLING_LINK_SELECTION_REMOVE = 'link_selection_remove'
export const TOOLBAR_TYPE_STYLING_POSITION = 'position'
export const TOOLBAR_TYPE_STYLING_SIZE = 'size'
export const TOOLBAR_TYPE_STYLING_SHAPE = 'shape'
export const TOOLBAR_TYPE_STYLING_UNDERLINE = 'underline'

export const DROPDOWN_STYLING_ITEMS = [
  TOOLBAR_TYPE_STYLING_POSITION,
  TOOLBAR_TYPE_STYLING_BACKGROUND,
  TOOLBAR_TYPE_STYLING_SHAPE,
  TOOLBAR_TYPE_STYLING_COLOR,
  TOOLBAR_TYPE_STYLING_FONT,
  TOOLBAR_TYPE_STYLING_LINK,
  TOOLBAR_TYPE_STYLING_SIZE,
]
